import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import apiClient from "../../../../../application/apis/api-client";
import {
  DefaultNumItemsPerPages,
  paging,
  toTotalPage,
} from "../../../../../application/domain/pagination/paging";
import { ProcedureAssignmentSettingRuleSetEntity } from "../../../../../application/domain/procedure-assignment-setting-ruleset/procedure-assignment-setting-ruleset-entity";
import { reportUnexpectedError } from "@graffer-inc/smart-apply";

export const useProcedureAssignmentSettingRuleSet = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [assignmentSettingRuleSets, setAssignmentSettingRuleSets] = useState<
    ProcedureAssignmentSettingRuleSetEntity[]
  >([]);
  const [pagingState, setPagingState] = useState<paging>({
    current: 1,
    total: 0,
  });
  const movePage = (page: number) => {
    setPagingState((prevPaging) => ({
      ...prevPaging,
      current: page,
    }));
  };

  const ruleSetCountPerPage = DefaultNumItemsPerPages;

  const fetchProcedureAssignmentSettingRuleSets = async () => {
    setIsLoading(true);
    try {
      const { data: rulesets, headers } =
        await apiClient.fetchProcedureAssignmentSettingRuleSets(
          pagingState.current,
          ruleSetCountPerPage,
        );
      setAssignmentSettingRuleSets(rulesets);
      setPagingState((prevPaging) => ({
        ...prevPaging,
        total: toTotalPage(
          Number(headers["pagination-count"]),
          ruleSetCountPerPage,
        ),
      }));
    } catch (error) {
      reportUnexpectedError(error);
      toast.error("申請振り分け設定の取得に失敗しました。");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    // TODO: permission check を追加する

    fetchProcedureAssignmentSettingRuleSets();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagingState.current]);

  return {
    isLoading,
    assignmentSettingRuleSets,
    paging: pagingState,
    movePage,
  };
};
